<template>
    <div v-if="category && (category.banners || []).length" class="visual">
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <div v-for="(banner, index) in category.banners" :key="index" class="swiper-slide">
                    <a class="visual__image" href="">
                        <picture>
                            <!-- 모바일 배너 -->
                            <source :srcset="banner" media="(max-width:768px)">
                            <!-- pc 배너 -->
                            <img :src="banner" alt="">
                        </picture>
                    </a>
                </div>
            </div>
        </div>
        <div class="visual__prev"></div>
        <div class="visual__next"></div>
        <div class="visual__pagination visual__pagination--bullet"></div>
    </div>
</template>

<script>
export default{
    props: {
        category: { type: Object, default: null }
    },
	mounted() {
		this.init();
	},
	methods : {
		init() {
            this.render();    
		},
        render(){
            this.$nextTick(() => {
                // 비주얼 슬라이드
                var slideVisual = new Swiper ('.visual .swiper-container', {
                    centeredSlides: true,
                    spaceBetween : 0,
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: false,
                    },
                    speed: 500,
                    loop: true,
                    pagination: {
                        el: '.visual__pagination',
                        clickable: true,
                    },
                    navigation: {
                        nextEl: '.visual__next',
                        prevEl: '.visual__prev'
                    },
                });
            });
        }
	},
    watch: {
        category(){
            if(this.category) this.render();
        }
    }
}
</script>
